import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-home',
  templateUrl: './faq-home.component.html',
  styleUrls: ['./faq-home.component.css']
})
export class FaqHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
